import { CurrencyType } from 'api/Wallet/Types/Wallet'

import { TradingAccountRestriction } from './TradingAccountRestriction'

export interface TradingAccountBalance {
  currency: CurrencyType
  balance: number
}
export interface TradingAccountDto {
  id: string
  name: string
  client: {
    id: string
    name: string
  }
  campaigns: { name: string; id: string }[]
  introducingBroker: string | null
  accountGroup: {
    id: string
    name: string
  }
  wallet: {
    id: string
    name: string
  }
  accountType: {
    id: number
    name: string
  }
  currency: {
    id: CurrencyType
    name: string
  }
  isTradingViewConnected: boolean | null
  status: {
    id: number
    name: string
  }
  country: null | string
  tickmillCompany: {
    id: number
    name: string
  }
  platformOverview: {
    balance: number
    equity: number
    freeMargin: number
    group: string
    lastEndOfDayBalance: number
    login: number
    marginLevel: number
    usedMargin: number
    balances: TradingAccountBalance[]
  }
  platformType: {
    id: number
    name: string
  }
  restrictions: TradingAccountRestriction[]
  selected: boolean
}

export enum TradingAccountKey {
  id = 'id',
  name = 'name',
  clientName = 'client.name',
  walletName = 'wallet.name',
  statusName = 'status.name',
  isTradingViewConnected = 'isTradingViewConnected',
  automaticClosure = 'automaticClosure',
  currencyId = 'currency.id',
  countryName = 'country.name',
  introducingBrokerName = 'introducingBroker.name',
  accountGroupName = 'accountGroup.name',
  accountGroupTypeName = 'accountGroupType.name',
  accountTypeName = 'accountType.name',
  tickmillCompanyName = 'tickmillCompany.name',
  createdDate = 'createdDate',
  updatedDate = 'updatedDate',
  platformType = 'platformType.name',
}

export enum TradingAccountFilterKey {
  externalID = 'ExternalId',
  id = 'id',
  name = 'Name',
  client = 'Client',
  wallet = 'Wallet',
  status = 'Status',
  book = 'Book',
  server = 'Server',
  leverage = 'Leverage',
  platform = 'Platform',
  currency = 'Currency',
  country = 'Country',
  introducingBroker = 'IB',
  accountGroup = 'AccountGroup',
  accountType = 'AccountType',
  accountGroupType = 'AccountGroupType',
  tickmillCompany = 'TickmillCompany',
  isInternalTestAccount = 'IsInternalTestAccount',
  createdDate = 'Created',
  updatedDate = 'Updated',
  isTradingViewConnected = 'IsTradingViewConnected',
}

export enum TradingAccountType {
  DEMO = 1,
  LIVE = 2,
  WELCOME = 3,
}

export enum TradingAccountStatus {
  None = 0,
  Approved = 1,
  Declined = 2,
  Archived = 3,
  ReadOnly = 4,
  Disabled = 5,
  Deleted = 6,
}
